<template>
  <div class="h1Title">
    <div class="h2-tit2"><span class="cont">{{ title1 }}</span></div>
    <div class="h2-tit1">{{ title2 }}</div>
  </div>
</template>

<script>
export default {
  name: "Title",
  props:['title1','title2']
}
</script>

<style lang="less" scoped>
.h1Title{
  text-align: center;
  .h2-tit1{
    text-transform: uppercase;
    padding-bottom: 0.05rem;
    font-size: 0.3rem;
  }
  .h2-tit2{
    font-weight: bold;
    font-size: 0.5rem;
    .cont{
      position: relative;
      &::after,&::before{position: absolute;width: 90px;height: 1px;background-color: currentColor;content: '';top: 50%;opacity: .65;}
      &::after{right: -120px;}
      &::before{left: -120px;}
    }
  }
}
</style>
